var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#99BED0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5887 7.25219L8.30968 11.6456C7.00794 12.9474 7.0079 15.0579 8.30964 16.3596C9.61139 17.6614 11.7219 17.6614 13.0237 16.3596L13.0242 16.3591L17.1958 12.1973C17.4565 11.9373 17.8786 11.9378 18.1386 12.1984C18.3987 12.4591 18.3982 12.8812 18.1375 13.1413L13.9665 17.3025C13.9664 17.3026 13.9666 17.3024 13.9665 17.3025C12.144 19.1246 9.18918 19.1248 7.36683 17.3025C5.54547 15.4811 5.54439 12.5287 7.3636 10.706L11.6429 6.31223C12.9447 5.01048 15.0553 5.01052 16.357 6.31227C17.6577 7.61293 17.6588 9.72103 16.3603 11.023L12.0809 15.4169C11.2999 16.1979 10.0335 16.1979 9.25245 15.4168C8.47141 14.6358 8.4714 13.3695 9.25245 12.5884L13.643 8.19789C13.9033 7.93754 14.3254 7.93754 14.5858 8.19789C14.8461 8.45824 14.8461 8.88035 14.5858 9.1407L10.1953 13.5312C9.93491 13.7916 9.93491 14.2137 10.1953 14.474C10.4547 14.7335 10.8749 14.7344 11.1355 14.4766L15.4142 10.0835C16.1952 9.30242 16.1953 8.03613 15.4142 7.25508C14.6341 6.47499 13.37 6.47403 12.5887 7.25219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFiles);
export default __webpack_public_path__ + "static/media/attach-files.aa0ba7bc461d895aeb4fd4abff7a5399.svg";
export { ForwardRef as ReactComponent };